/**
 * Die interne Portal-Mail-ID (email_log.id), dezent im Kopf einer Mail (#155).
 *
 * Paul: „Bitte zukünftig in Mails auch die ID irgendwo anzeigen, damit ich es
 * im Screenshot sehen kann und dir per Bugmeldung übertragen wird."
 *
 * Zwei Aufgaben:
 *   1. sichtbar — im Screenshot lesbar. Bewusst NICHT unter `data-pii`: die
 *      Schwärzung beim „Problem melden" soll die Kennung stehen lassen.
 *   2. `data-kontext-mail-id` — `sammleKontext()` (lib/problemKontext.ts) liest
 *      daraus die ID der GEÖFFNETEN Mail. In der Mailliste steckt sie nur im
 *      React-State, nicht in der URL; dort kam bisher `ids: {}` an.
 *
 * Keine HERO-ID — die Portal-Mail-ID darf gezeigt werden.
 */
export function MailIdMarke({ id, className, style }: {
  id: number | string | null | undefined
  className?: string
  style?: React.CSSProperties
}) {
  if (id === null || id === undefined || id === "") return null
  return (
    <span
      data-kontext-mail-id={String(id)}
      data-frei
      className={className}
      title="Interne Mail-ID im Portal — bei einer Problem-Meldung hilft sie, die Mail zu finden"
      style={{
        fontSize: 11, color: "var(--text-muted, #94a3b8)", fontVariantNumeric: "tabular-nums",
        whiteSpace: "nowrap", userSelect: "all", ...style,
      }}
    >
      Mail-ID {String(id)}
    </span>
  )
}
